"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { AccountSessionMixins } from "@/service/account-session";
import API from "@ym-framework/api-utils";
import { Component, Mixins, PropSync } from "vue-property-decorator";
let BatchRemoveTeam = class extends Mixins(AccountSessionMixins) {
  get show() {
    let flag = true;
    for (let item of this._controller) {
      if (item.status !== "wait") {
        flag = false;
      }
    }
    return flag;
  }
  refuseMember() {
    return __async(this, null, function* () {
      try {
        let arr = [];
        for (let item of this._controller) {
          arr.push(item.member_guid);
        }
        yield API.post(`api://base.auth/api/v1/team/members/audit`, {
          member_guids: arr,
          status: "refuse"
        });
        this.$emit("refresh");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  PropSync("selectItem")
], BatchRemoveTeam.prototype, "_controller", 2);
BatchRemoveTeam = __decorateClass([
  Component
], BatchRemoveTeam);
export {
  BatchRemoveTeam as default
};
